import { html, css } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { TeComponent } from './common/te-component';
import { theme } from './common/theme';
import './te-icon';
import './te-text';

/** Version Selector Component */
@customElement('te-version-selector')
export class TeVersionSelector extends TeComponent {
  static styles = [
    ...TeComponent.styles,
    css`
      .te-version-wrapper {
        position: relative;
        margin-bottom: 24px;
        height: 20px;
        padding: 8px;
      }

      .version-dropdown {
        height: 20px;
        color: ${theme.colors.text};
        border-radius: 4px;
        padding: 0 16px;
        margin: 0 16px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
      }

      .version-dropdown-selected {
        margin-right: 8px;
      }

      .version-dropdown-menu {
        box-shadow: ${theme.shadows.secondary};
        position: absolute;
        top: 40px;
        left: 0;
        background: ${theme.colors.shade1};
        color: ${theme.colors.text};
        z-index: 1;
        border-radius: 4px;
        width: calc(100% - 32px);
        margin: 0 16px;
        overflow: hidden;
      }

      .version-dropdown-menu-item {
        display: flex;
        align-items: center;
        padding: 0 16px;
        height: 40px;
        cursor: pointer;
      }

      .version-dropdown-menu-item:hover {
        background: ${theme.colors.shade2};
      }
    `,
  ];

  constructor() {
    super();

    const versions = sessionStorage.getItem('versions');

    if (versions) {
      this.versions = JSON.parse(versions);
    } else {
      // TODO: What should happen if version loading fails?
      fetch('https://te-web-versions.s3.eu-central-1.amazonaws.com/versions.json').then(
        async (res) => {
          this.versions = await res.json();
          sessionStorage.setItem('versions', JSON.stringify(this.versions));
        }
      );
    }
  }

  @state() private _isOpen = false;
  @state() private versions: string[] | undefined;

  toggleMenu() {
    this._isOpen = !this._isOpen;
  }

  select(selectedVersion: string) {
    if (!this.versions) return;

    this._isOpen = false;
    const path = window.location.pathname.split('/');
    const rootPath = path[1];
    const latestVersion = this.versions[this.versions.length - 1];
    const currentlyOnNonRootVersion = this.versions.includes(rootPath);

    if (selectedVersion === latestVersion && currentlyOnNonRootVersion) {
      path.splice(1, 1);
      location.href = path.join('/');
    } else if (currentlyOnNonRootVersion) {
      path[1] = selectedVersion;
      location.href = path.join('/');
    } else {
      path.splice(1, 0, selectedVersion);
      location.href = path.join('/');
    }
  }

  // TODO: Refactor to use some list component if we eventually will have one
  render() {
    if (!this.versions) {
      // TODO: Spinner?
      return html`
        <div class="te-version-wrapper"></div>
      `;
    }
    const latestVersion = this.versions[this.versions.length - 1];
    const rootPath = window.location.pathname.split('/')[1];
    const selectedVersion = this.versions.includes(rootPath) ? rootPath : latestVersion;

    return html`
      <div class="te-version-wrapper">
        <div class="version-dropdown" @click=${this.toggleMenu}>
          <div class="version-dropdown-selected">
            Version: ${selectedVersion}
          </div>
          <te-icon name="triangle-down" size="9"></te-icon>
        </div>
        ${this._isOpen
          ? html`
              <div class="version-dropdown-menu">
                ${this.versions.map((version: string) => {
                  return html`
                    <div class="version-dropdown-menu-item" @click=${() => this.select(version)}>
                      <te-text size="14">${version}</te-text>
                    </div>
                  `;
                })}
              </div>
            `
          : html``}
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'te-version-selector': TeVersionSelector;
  }
}
